const toAttentionCount = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number) || number <= 0) return 0;
  return Math.floor(number);
};

export const getMailboxAttentionCount = (
  unreadMailboxCount,
  pendingRequiredActionsCount
) => Math.max(
  toAttentionCount(unreadMailboxCount),
  toAttentionCount(pendingRequiredActionsCount)
);

export const getChatsAttentionCount = (
  unreadChatsCount,
  unreadMailboxCount,
  pendingRequiredActionsCount
) => (
  toAttentionCount(unreadChatsCount)
  + getMailboxAttentionCount(unreadMailboxCount, pendingRequiredActionsCount)
);
